export default function IconWatch() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM8.7926 13.7581L13.4382 10.4054C13.7147 10.2059 13.7147 9.79413 13.4382 9.59456L8.7926 6.24188C8.46192 6.00324 8 6.23952 8 6.64733V13.3527C8 13.7605 8.46192 13.9968 8.7926 13.7581Z"
                fill="currentColor"
            />
        </svg>
    );
}
